var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1282 5.625L13.514 2.94104L12.2068 0H3.79315L2.48596 2.94104L4.87183 5.625H11.1282Z",
    fill: "#8B857E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5916C7.76325 13.5916 7.52869 13.5778 7.29688 13.5515V15L6.38336 18.5457L7.99982 20.4344L9.61664 18.5457L8.70313 15V13.5515C8.47131 13.5778 8.23676 13.5916 8 13.5916Z",
    fill: "#8B857E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 11.6058C12.4398 11.6746 12.3755 11.7424 12.3088 11.809C11.6757 12.4422 10.9266 12.9183 10.1094 13.2186V14.2209L11.1399 18.9283L7.99963 22.5969L4.85992 18.9283L5.89062 14.2209V13.2186C5.07343 12.9185 4.32434 12.4422 3.69098 11.809C3.62451 11.7424 3.56024 11.6746 3.49744 11.6058C1.97968 12.5605 0.96875 14.2502 0.96875 16.1719V24H15.0312V16.1719C15.0312 14.2502 14.0203 12.5605 12.5026 11.6058Z",
    fill: "#8B857E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5016 6.19666L11.7597 7.03125H4.2403L3.49835 6.19666C3.04187 7.78381 3.43719 9.56653 4.68542 10.8146C5.5993 11.7285 6.79938 12.1853 8 12.1853C9.20007 12.1853 10.4009 11.7283 11.3146 10.8146C12.5626 9.56653 12.9581 7.78381 12.5016 6.19666Z",
    fill: "#8B857E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/Drivers.df865f5dd5564283733577a642e7a0e3.svg";
export { ForwardRef as ReactComponent };